import { render } from "./TeoHosts.vue?vue&type=template&id=2af1e37b"
import script from "./TeoHosts.vue?vue&type=script&lang=js"
export * from "./TeoHosts.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__